import { Avatar, Box, Typography } from "@mui/material"
import { User } from "../Utilis/Types/User";
import { CaretDown } from "phosphor-react";
import LayoutItems from "./Layout/LayoutItems";
import { useEffect, useRef, useState } from "react";
import { SidebarItem } from "./Sidebar/types";

type Props = {
    user: Partial<User> | null;
    dropdownItems?: SidebarItem[];
}

const AccountMenu = ({ user, dropdownItems }: Props) => {
    const [isDropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const dropdownRef: any = useRef(null);

    const closeDropdown = (e: any) => {
        if (dropdownRef.current && isDropdownOpen && !dropdownRef.current.contains(e.target)) {
            setDropdownOpen(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', closeDropdown)
        return () => document.removeEventListener('mousedown', closeDropdown)
    }, [])

    if (!user) return null;

    return (
        <Box
            ref={dropdownRef}
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "8px",
                position: "relative",
                cursor: "pointer",
            }}
            onClick={() => setDropdownOpen(!isDropdownOpen)}
        >
            <Box 
                sx={{ 
                    display:"flex",
                    justifyContent: 'space-between',
                    alignItems:"center", 
                    padding: "16px 16px", 
                    border: "1px solid #E3DDE6",
                    borderRadius: "4px",
                    width: '100%',
                    gap: '5px'
                }}
            >
                <Box sx={{ display: 'flex', gap: '5px', alignItems:"center" }}>
                    <Avatar
                        src={user?.profile}
                        sx={{
                            width: "24px",
                            height: "24px",
                        }}
                        alt={`${user?.name} ${user?.lastName}`}
                    />
                    <Typography
                        variant="body1"
                        color={"#202A2D"}
                        fontWeight={"500"}
                        fontSize={"16px"}
                        whiteSpace={"nowrap"}
                        // fontFamily={'Inter, sans-serif'}
                    >
                        {user?.name} {user?.lastName}
                    </Typography>
                </Box>
                <CaretDown size={18} color={"#736977"} />
            </Box>
            {!!dropdownItems && !!isDropdownOpen && (
                <Box
                    sx={{
                        bgcolor: "#FFFFFF",
                        border: "1px solid #E3DDE6",
                        borderRadius: "4px",
                        padding: "16px 4px",
                        width: "100%",
                        position: "absolute",
                        bottom: "65px",
                        zIndex: 1,
                        boxShadow: "0px 2px 20px -98px rgba(29, 49, 55, 0.12)",
                        boxSizing: 'border-box'
                    }}
                >
                    <Box 
                        sx={{
                            display: "flex", 
                            flexDirection: "column", 
                            gap: "5px",
                        }}
                    >
                        {dropdownItems
                            .map((item) => (
                                <LayoutItems
                                    item={item}
                                    key={item.title}
                                    selected={item.selected}
                                    onClick={item.onClick}
                                />
                            ))
                        }
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default AccountMenu